export const VERSION = "/api/v2";
export const LOGIN_ENDPOINT = "/auth/login";
export const LOGOUT_ENDPOINT = "/auth/logout";
export const REGISTER_ENDPOINT = "/auth/register";
//export const BASE_URL = "http://a2zhoteldev.snpnextgen.com:8088/hmgmt_prod";
export const BASE_URL = "https://a2zhotel.snpnextgen.com";
//export const BASE_URL = "https://a2zhoteldev.snpnextgen.com";
export const LOCAL_BASE_URL = "http://localhost:8087/hmgmt_test";
export const BACKEND_BASE_URL = `${BASE_URL}${VERSION}/hotel/`;
export const DASHBOARD_BASE_URL = `${BASE_URL}${VERSION}/dashboard/`;
export const REPORT_BASE_URL = `${BASE_URL}${VERSION}/report/`;
export const ADMIN_BASE_URL = `${BASE_URL}${VERSION}/api/admin/v1/`;
export const TEST_BACKEND_BASE_URL = LOCAL_BASE_URL + VERSION + "/";
export const AXIOS_TIMEOUT = 300000;
// INITIAL STATE
export const GET_CATEOGORY_DATA = 'show_catg';
export const SET_CATEOGORY_DATA = 'create_update_catg';
export const GET_ROOM = 'fetchRoomDetails';
export const SET_ROOM = 'updateRoomDetails';
export const GET_BOOK_DETAILS = 'fetchRoomBookDetails';
export const GET_BILL_DETAILS = 'fetchBillOrRoomDetails';
export const GET_CUST_BY_MOB = 'fetchSingleCustomer';
export const GET_CUST = 'fetchCustomer';
export const SET_CUSTOMER = 'update_customer_data';
export const GET_FEW_ROOM_DETAILS = 'fetchFewRoomDetails';
export const UPDATEBILL = 'updateBill';
export const SHOWALLBILLS = 'show-all-bills';
export const GET_ACCOUNTING_DATA = 'get-accounting-details-v2';
export const GET_STAYS_DAY = 'get-stay-days';
export const DEL_CUST_BILL = 'delete-cust-bill';
export const DEL_ROOM_BILL = 'delete-room-bill';
export const DEL_ENTIRE_BILL = 'delete-entire-bill';

export const RESYMBOL = '₹';
export const CREDIT = 'Cr';
export const DEBIT = 'Dr';

export const INVALIDBILL = 101;
export const SUCCESS = 200;
export const UPDATEHOMEDELIVERY = 201;
export const ROLEUPDATE = 202;
export const SUCCESSENTIREBILLDEL = 203;
export const FAILED = 401;
export const NODATA = 402;
export const NULLDATA = 404;
export const ROLEERROR = 406;
export const ACCESSDENIED = 407;
export const SESSIONEXPIRED = 408;
export const FIELD_EMPTY = 409;
export const SHOPNOTACCESSERROR = 410;
export const VALIDITYEXPIREDERR = 411;

export const NUM_DECIMAL_CHECK_REGEX = /^[0-9]*\.?[0-9]*$/;
export const NUM_WITHOUT_DECIMAL_CHECK_REGEX = /^[0-9]*$/;


export const PDFEXTENSION = "pdf";
export const EXCELEXTENSION = "xlsx";


export const ItemStatus = {
	ACTIVE: 1,
	INACTIVE: 2,
	ITEMDELETED: 3
};

export const CustRelationChoice = {
	SPOC: 1,
	RELATIVE: 2,
};


export const CustSex = {
	Male: "Male",
	Female: "Female",
	Other: "Other",
};

export const OfferType = {
	No_Offer: 1, Flat: 2, Percentage: 3, ONVALUE_FLAT: 4, ONVALUE_PERC: 5, Multi: 6
};

export const PayMedium = {
	NOT_SELECTED: -1,
	ONLINE: 0,
	CASH: 1,
	BOTH: 2
};

export const BillStatus = {
	INUI: -1,
	MODE_ESTIMATION: 0,
	ROOMALLOTEDNOTPAID: 3,
	ROOMALLOTEDPAID: 4,
	ROOMALLOTEDPAIDBUTRESTAURANTNOTPAID: 5,
	ROOMALLOTEDPARTIALPAID: 6,
	BILLSETTLED: 7,
	BILLSETTLEDBUTINDUES: 8,
	CANCELLED_BILL: 9,
};

export const HotelRoomCateogory = {
	HOTEL_ROOM: 1,
	HOTEL_BANKQUET: 2,
	HOTEL_BOTH: 3,
};

export const GraphChoice = {
	DAYS_OF_WEEK: 1,
	WEEK_OF_MONTH: 2,
	MONTH_OF_YEAR: 3,
};

export const BillSearchMode = {
	NA: -1,
	BY_MOBILE: 0,
	BY_BOOKING_ID: 1,
	BY_INVOICE_ID: 2,
};

export const RateCardType = {
	HOTEL_NORMAL: 1,
	HOTEL_CORPORATE: 2
};

export const StayType = {
	DAILY: 1,
	HOURLY: 2
};

export const BookingTimeRangeType = {
	PARTIAL: 0,
	FULL: 1,
	NOT_BOOKED: 2
};

export const UiButtonAction = {
	PAY: 0,
	SAVE_BILL: 1,
	PRINT: 2,
	SETTLE: 3,
	PAY_WITH_LINK: 4,
	CANCEL_BILL: 5,
	GENERATE_ESTIMATION: 11,
};

export const UiGridAction = {
	ROOM: 0,
	CUSTOMER: 1,
	RESTO: 3
};


export const BookStatus = {
	No_Booking: 0, Single_Booking: 1, Multiple_Booking: 2,
};

export const RoomBillTableBtnClick = {
	No_Booking_Click: 0, New_Booking_Click: 1, Existing_Booking_Click: 2
}

export const CustKycDetails = {
	INTERNAL: 1,
	GOOGLE_DRIVE: 2,
};

export const ConfigInputType = {
	LABEL: 1,
	ATTACHMENT: 2,
	RADIO: 3,
	COLORPALLETE: 4,
	NUMBER: 5,
	DATE: 6,
	BOOL: 7,
	LIST: 8,
	MAP: 9,
};

export const AccountingPayStatus = {
	ACC_FULL_PAID: 4, ACC_PARTIAL_PAID: 6
};

export const AccountingPaidMode = {
	MISC: 1, VIASTOCK: 2, VIASUPPLIER: 3, VIABILL: 4, CLEAR_CASH_BALANCE: 5,
	OWNER_TRANSFER_TO_BANK: 6, VIA_RESTO: 7
};

export const ConfigType = {
	SNP: 0,
	SNPMULTITYPE: 1,
	// Only Shop Owner
	ONLY_OWNERVISIBLE: 2,
	ONLY_OWNERNOTVISIBLE: 3,
	ONLY_OWNERMULTIVISIBLE: 4,
	ONLY_OWNERMULTINOTVISIBLE: 5,
	// ALL Person
	ALL_EMPLOYEEVISIBLE: 6,
	ALL_EMPLOYEENOTVISIBLE: 7,
	ALL_EMPLOYEEMULTIVISIBLE: 8,
};


export const ReportFilter = {
	DATE_FILTER: 0, EMPLOYEE: 1, BILL_TYPE: 2, PAY_METHODS: 3, GST_FEATURE: 4, CUSTOMER: 5, ACCOUNT_LEDGER_TYPE: 6,
	BILL_STATUS: 7,


}

export const WidgetType = {
	OWNER_DASHBOARD: "OwnerDashboard",
	BOOK_ROOM: "BookRoom",
	BOOK_BANQUET: "BookBanquet",
	SHOW_BOOKINGS: "ShowBookings",
};

export function isEmpty(val) {
	//console.log("isEmpty",val);
	if (val === undefined) return true;
	if (val === null) return true;
	return (val.length <= 0) ? true : false;
}

export function isNumberEmpty(val) {
	if (isNaN(val)) return true;
	if (val === undefined) return true;
	if (val === null) return true;
	return (val.length === 0) ? true : false;
}

export function isValidDate(day, month, year) {
	const dateObject = new Date(`${month}/${day}/${year}`);
	return !isNaN(dateObject);
};


export function formatDateInSnp(dateString) {
	// Validate the date string(yyyy-mm-dd) and format it as dd/mm/yyyy
	// Example implementation:
	if (isEmpty(dateString))
		return '';
	if (dateString.includes('-')) {
		const [year, month, day] = dateString.split('-');
		const validDate = isValidDate(day, month, year);
		if (validDate) {
			const formattedDate = `${day}/${month}/${year}`;
			return formattedDate;
		}
	}
	return dateString; // Return the previous value if the input is invalid
};

export function formatDateInReact(dateString) {
	// Validate the date string and format it as dd/mm/yyyy
	// Example implementation:
	//console.log("formatDateInReact",dateString);
	if (isEmpty(dateString))
		return '';
	if (dateString.includes('/')) {
		const [day, month, year] = dateString.split('/');
		let rYear = ''
		if (year.includes(':')) {
			rYear = year.substring(0, 4);
		} else
			rYear = year;
		const validDate = isValidDate(day, month, rYear);
		if (validDate) {
			const formattedDate = `${rYear}-${month}-${day}`;
			return formattedDate;
		}
	}
	return dateString; // Return the previous value if the input is invalid
};

export function DateDiff(f, t) {
	// Example dates
	const from = formatDateInReact(f);
	const to = formatDateInReact(t);
	const date1 = new Date(from);
	const date2 = new Date(to);

	// Calculate the difference in milliseconds between the dates
	const diffInMilliseconds = Math.abs(date2 - date1);

	// Convert milliseconds to days
	const diffInDays = Math.ceil(diffInMilliseconds / (1000 * 60 * 60 * 24));
	return diffInDays;
};

export function AddDays(dateStr, days) {
	const date = new Date(formatDateInReact(dateStr));
	//console.log("AddDays",dateStr , date);
	// Create a new date by adding 1 day to the original date
	const newDate = new Date(date.setDate(date.getDate() + days));
	const str = formatDateInReact(newDate.toLocaleDateString());
	//console.log("AddDays",newDate.toLocaleDateString(),str);
	return str;
};


export function printDebugLog(first, ...msg) {
	console.group(`[D] ${first}`);
	msg.forEach((m, i) => console.log(`${i + 1}]:`, m));
	console.groupEnd();
}

export const isFeatureAllowed = (features, keys) => {
	if (features) {
		if (features.length === 0) {
			return true;
		}
	} else {
		return true;
	}
	let resp = false;
	if (Array.isArray(keys)) {
		for (const key of keys) {
			resp |= features[key];
		}
	} else {
		resp = features[keys];
	}
	return resp;
};